import React, { useState } from "react";
import styles from './partList.module.css';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  Divider, Grid,

} from "@mui/material";
import { Delete, Payment } from "../../../Svg";

const PartList = ({ data, deleteProductFromenq, status }) => {


  return (
    <>
      <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", marginTop: "26px" }}>
        <Box sx={{ p: 2, }} display="flex" alignItems="center" >
          <Payment />
          <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600", }}>
            Product
          </Typography>
          <Typography style={{ marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", background: "#EAFFFE", color: '#006C64' }}>
            {data?.length} Products
          </Typography>
        </Box>
        <div className={styles.previewContainer}>
          <table className={styles.previewtable}>
            <thead>
              <tr>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Sl No</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Manufacture Part #</th>
                <th className={styles.previewth} style={{ borderRight: '1px solid #0000001A' }}>Quantity</th>
                <th className={styles.previewth}>Manufacture/purchase order #</th>
                <th className={styles.previewth}></th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.id} className={styles.previewstripedRow}>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{index + 1}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item.productNumber}</td>
                  <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A' }}>{item.quantity}</td>
                  <td className={styles.previewtd}>
                    <div className={styles.closetd}>
                      {item.manufacturer}
                    </div></td>
                  <td className={styles.previewtd}>
                    {status !== 'COMPLETED' && deleteProductFromenq && (
                      <div className={styles.closetd} onClick={() => deleteProductFromenq(item?._id)} style={{ cursor: 'pointer' }}>
                        <Delete />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


          {/*  <div className={styles.displayFlex}>
          <button className={styles.cancelBtn}>Back</button>
          <button className={styles.submitBtn}>Submit</button>
        </div> */}
        </div>
      </Paper>
    </>
  );
};

export default PartList;
